import { render, staticRenderFns } from "./NorticList.vue?vue&type=template&id=f21274bc&scoped=true&"
import script from "./NorticList.vue?vue&type=script&lang=js&"
export * from "./NorticList.vue?vue&type=script&lang=js&"
import style0 from "./NorticList.vue?vue&type=style&index=0&id=f21274bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21274bc",
  null
  
)

export default component.exports